const { default: axiosIns } = require('@/libs/axios')

const SurveysService = {
  // GET - SurveyApiController
  async getSurveys(accountId, skip, take) {
    return axiosIns.get('/surveys', {
      params: { accountId, skip, take },
    }).then(response => response.data)
  },
  async getSurvey(surveyId, accountId) {
    return axiosIns.get(`surveys/${surveyId}?accountId=${accountId}`).then(response => response.data)
  },
  async getSurveyConfiguration(accountId) {
    return axiosIns.get(`/surveys/configuration?accountId=${accountId}`).then(response => response.data)
  },
  async getSurveyDetails(surveyId, accountId) {
    return axiosIns.get(`/surveys/details/${surveyId}?accountId=${accountId}`).then(response => response.data)
  },
  async getChart(surveyId, accountId) {
    return axiosIns.get(`/surveys/${surveyId}/chart?accountId=${accountId}`).then(response => response.data)
  },
  async getSearchSurveyTargetingDetails(surveyId, accountId) {
    return axiosIns.get(`/surveys/${surveyId}/targeting?accountId=${accountId}`).then(response => response.data)
  },
  async export(surveyId, accountId) {
    return axiosIns.get(`/surveys/${surveyId}/export/excel?accountId=${accountId}`, { responseType: 'blob' }).then(response => response.data)
  },
  // POST - SurveyApiController
  async duplicateSurvey(surveyId, accountId) {
    return axiosIns.post(`/surveys/${surveyId}?accountId=${accountId}`).then(response => response.data)
  },
  async createSurvey(survey, accountId) {
    return axiosIns.post(`/surveys?accountId=${accountId}`, survey).then(response => response.data)
  },
  async previewSurvey(survey, accountId) {
    return axiosIns.post(`/surveys/preview?accountId=${accountId}`, survey).then(response => response.data)
  },
  async getSurveyPreviewHtml(surveyWrapperModel, type = 1) {
    const centralBaseUrl = process.env.VUE_APP_CENTRAL_API_URL
    return axiosIns.post(`${centralBaseUrl}/survey-preview?type=${type}`, surveyWrapperModel, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => response.data)
  },
  // PUT - SurveyApiController
  async updateSurvey(survey, accountId) {
    return axiosIns.put(`/surveys/${survey.id}?accountId=${accountId}`, survey).then(response => response.data)
  },
  // DELETE - SurveyApiController
  async deleteSurvey(surveyId, accountId) {
    return axiosIns.delete(`/surveys/${surveyId}?accountId=${accountId}`).then(response => response.data)
  },
}

export default SurveysService
